<template>
    <div>
        <vue-select
            :value="name"
            :options="options_filtered"
            :get-option-label="(option) => { return option.text }"
            :size="size"
            :reduce="v => v.value"
            :filter="filterOption"
            @input="input"

            append-to-body
            :calculate-position="withPopper"
            >
        </vue-select>

        <div v-if="option_selected">
            <span>登録番号の発行国</span>
            <vue-select
                :value="issuer_country_code"
                :options="option_selected.issuer_country_code"
                :size="size"
                @input="input_issuer_country_code"

                append-to-body
                :calculate-position="withPopper"
                >
            </vue-select>

            <small class="text-secondary" style="white-space: pre;">{{ option_selected.note }}</small>
        </div>
    </div>
</template>

<script>
import Fuse from 'fuse.js'
import { createPopper } from '@popperjs/core'

export default {
    components: {
    },
    props: {
        value: {
            type: String,
            required: false,
            default: '',
        },
        size: {
            type: String,
            required: false,
            default: 'sm',
        },
        target: {
            type: String,
            required: true,
            default: '',
        },
    },
    data() {
        return {
            DELIMITER: '___',
            name: null,
            issuer_country_code: null,
            options: [
                // from
//                {
//                    target: 'from',
//                    issuer_country_code: [ 'NZ', ],
//                    name: 'IRD番号 Overseas Registered Supplier,
//                    type_code: 'SDT',
//                    note: '8~9桁の数字',
//                    to_country: 'United Kingdom',
//                },
//                {
//                    target: 'from',
//                    issuer_country_code: [ 'NO', ],
//                    name: 'VOEC番号 VAT on E-Commerce',
//                    type_code: 'SDT',
//                    note: '2で始まる7桁の数字',
//                    to_country: 'Norway',
//                },
//                {
//                    target: 'from',
//                    issuer_country_code: [ 'AU', ],
//                    name: 'AUSID番号 AUSidGST Registration',
//                    type_code: 'SDT',
//                    note: '11~12桁の数字',
//                    to_country: 'Australia',
//                },
//                {
//                    target: 'from',
//// EU list
//                    issuer_country_code: [ 'TODO:EU', ],
//                    name: 'IOSS番号 Import One-Stop-Shop',
//                    type_code: 'SDT',
//                    note: 'IM+10桁の数字',
//                    to_country: 'EU加盟国',
//                },
//                {
//                    target: 'from',
//                    issuer_country_code: [ 'GB', ],
//                    name: 'UKVAT番号 GBVAT (foreign) Registration',
//                    type_code: 'SDT',
//                    note: 'GB+12桁の数字',
//                    to_country: 'United Kingdom',
//                },
//                {
//                    target: 'from',
//                    issuer_country_code: [ 'SG', ],
//                    name: 'GST登録番号 Singapore GST Collected',
//                    type_code: 'SDT',
//                    note: '9~10桁の数字',
//                    to_country: 'Singapore',
//                },
//                {
//                    target: 'from',
//                    issuer_country_code: [ 'MY', ],
//                    name: '登録販売者（RS）番号 Malaysia Low Value Registration Number',
//                    type_code: 'SDT',
//                    note: '10桁の英数字',
//                    to_country: 'Malaysia',
//                },
                {
                    target: 'from',
                    issuer_country_code: [ 'JP', ],
                    name: '輸出者の日本の法人番号',
                    type_code: 'VAT',
                    note: `<法人番号をお持ちのお客様> 
法人番号検索サイト：https://www.houjin-bangou.nta.go.jp/
・13桁 
・支店コードのご指定がある場合は末尾4桁の支店コードを含む17桁
<法人番号がないお客様> 
・税関発給コードをお持ちの場合　17桁 
・JASTPROコードをお持ちの場合　12桁`,
                    to_country: 'すべて',
                },

                // to
                {
                    target: 'to',
                    issuer_country_code: this.$store.state.app.data.countries.map((v) => { return v.value }),
// TODO:よーろっぱ list
                    name: 'EORI番号',
                    type_code: 'EOR',
                    note: '発行国コード2文字+最大15桁の数字',
                    to_country: 'ヨーロッパ',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'ID', ],
                    name: 'NPWP番号',
                    type_code: 'VAT',
                    note: '15桁の数字',
                    to_country: 'Indonesia',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'ID', ],
                    name: 'ID番号',
                    type_code: 'NID',
                    note: '16桁の数字',
                    to_country: 'Indonesia',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'ID', ],
                    name: '運転免許証番号',
                    type_code: 'DLI',
                    note: '13桁の数字',
                    to_country: 'Indonesia',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'ID', ],
                    name: 'パスポート番号',
                    type_code: 'PAS',
                    note: 'アルファベットと数字',
                    to_country: 'Indonesia',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'KR', ],
                    name: 'PCCC',
                    type_code: 'VAT',
                    note: '8~13桁/ P+12桁の数字',
                    to_country: 'South Korea',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'CN', ],
                    name: '輸出入者登録番号（CR番号）',
                    type_code: 'RGP',
                    note: '',
                    to_country: 'China',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'CN', ],
                    name: '統一社会信用コード（USCI番号）',
                    type_code: 'DUN',
                    note: '',
                    to_country: 'China',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'BR', ],
                    name: 'CNPJ番号（法人）',
                    type_code: 'CNP',
                    note: '17桁の数字',
                    to_country: 'Brazil',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'BR', ],
                    name: 'CPF番号（個人）',
                    type_code: 'CNP',
                    note: '14桁の数字',
                    to_country: 'Brazil',
                },
                {
                    target: 'to',
                    issuer_country_code: [ 'CL', ],
                    name: 'VAT番号',
                    type_code: 'VAT',
                    note: '',
                    to_country: 'Chile',
                },

                // ebay
                {
                    target: 'ebay',
                    issuer_country_code: [ 'GB', ],
                    name: 'UKVAT番号 GBVAT (foreign) Registration',
                    type_code: 'SDT',
                    note: `（例）GB365608576
イギリス宛て
135ポンド以下`,
                    to_country: 'United Kingdom',
                },
                {
                    target: 'ebay',
                    issuer_country_code: [ 'DE', ],
                    name: 'IOSS番号 Import One-Stop-Shop',
                    type_code: 'SDT',
                    note: `（例）IM2760000742
EU加盟国宛て
150ユーロ以下`,
                    to_country: 'EU加盟国',
                },
                {
                    target: 'ebay',
                    issuer_country_code: [ 'AU', ],
                    name: 'AUS ID番号（ABN#） AUSid GST Registration',
                    type_code: 'SDT',
                    note: `（例）64652016681
オーストラリア宛て
1,000オーストラリアドル以下`,
                    to_country: 'Australia',
                },
                {
                    target: 'ebay',
                    issuer_country_code: [ 'NZ', ],
                    name: 'IRD番号 Overseas Registered Supplier',
                    type_code: 'SDT',
                    note: `（例）126101678（ハイフン含まず）
ニュージーランド宛て
1,000ニュージーランドドル以下`,
                    to_country: 'New Zealand',
                },
                {
                    target: 'ebay',
                    issuer_country_code: [ 'NO', ],
                    name: 'VOEC番号 VAT on E-Commerce',
                    type_code: 'SDT',
                    note: `（例）2024926
ノルウェ―宛て
3,000クローネ以下`,
                    to_country: 'Norway',
                },


                // IOSS
                {
                    target: 'ioss',
                    issuer_country_code: this.$store.state.app.data.countries_eu,
                    name: 'IOSS番号 Import One-Stop-Shop',
                    type_code: 'SDT',
                    note: `IM+10桁の数字
EU加盟国宛て
150ユーロ以下`,
                    to_country: 'EU加盟国',
                },

                // GB VAT
                {
                    target: 'gb',
                    issuer_country_code: [ 'GB', ],
                    name: 'UKVAT番号 GBVAT (foreign) Registration',
                    type_code: 'SDT',
                    note: `GB+9桁の数字
イギリス宛て
135ポンド以下`,
                    to_country: 'United Kingdom',
                },
            ],
        }
    },
    computed: {
        options_filtered() {
            let options = this.options
                .filter((v) => {
                    return v.target === this.target
                })
                .map((v) => {
                    v.text = v.name + '（受取国:' + v.to_country + '）'
                    v.value = v.target + this.DELIMITER + v.type_code + this.DELIMITER + v.name
                    return v
                })
            return options
        },
        option_selected() {
            return this.options_filtered
                .filter((v) => {
                    return v.value === this.name
                })
                .shift()
        },
    },
    watch: {
        value: {
            async handler (value) {
                this.parseValue(value)
            },
            immediate: true,
        },
    },
    async mounted() {
//        this.$watch('value', (value_new, value_old) => {
//console.log(value_old)
//console.log(value_new)
//            this.parseValue(value_new)
//        }, {
//            immediate: true, // オプション
//        })
    },
    methods: {
        parseValue(value) {
            if (!value) {
                return
            }
            let vals = (value || '').split(this.DELIMITER)
            if (vals.length === 4) {
                this.name = [ vals[0], vals[1], vals[2], ].join(this.DELIMITER)
                this.issuer_country_code = vals[3]
            }
            this.$forceUpdate();
        },
        stringifyValue() {
            let vals = (this.name || '').split(this.DELIMITER)
            if (vals.length === 3) {
console.log( [ vals[0], vals[1], vals[2], this.issuer_country_code, ].join(this.DELIMITER) )
                return [ vals[0], vals[1], vals[2], this.issuer_country_code, ].join(this.DELIMITER)
            }

console.log(
            [ '','','','', ].join(this.DELIMITER)
)
            return [ '','','','', ].join(this.DELIMITER)
        },
        filterOption(options, search) {
            const fuse = new Fuse(options, {
                keys: [ 'value', 'text', ],
                shouldSort: true,

                tokenize: true,
//                ignoreLocation: true,

                includeMatches: true,
                minMatchCharLength: 1,
                threshold: 0.9,
            })
setTimeout(() => {
    const dropdownList = document.querySelector('ul.vs__dropdown-menu')
    if (dropdownList) {
        console.log(dropdownList.scrollTop = 0)
    }
} , 1)
            return search.length
                ? fuse.search(search).map(({ item }) => item)
                : fuse.list
        },
        input(value) {
console.log('input')
            this.name = value
            this.issuer_country_code = null
console.log(value)
            this.$emit('input', this.stringifyValue())
        },
        input_issuer_country_code(value) {
console.log('input_issuer_country_code')
            this.issuer_country_code = value
console.log(value)
            this.$emit('input', this.stringifyValue())
//            if (this.name && this.issuer_country_code) {
//                this.$emit('input', this.name + this.DELIMITER + this.issuer_country_code)
//            } else {
//                this.$emit('input', null)
//            }
        },

        withPopper(dropdownList, component, { width }) {
            /**
             * We need to explicitly define the dropdown width since
             * it is usually inherited from the parent with CSS.
             */
            dropdownList.style.width = width
            dropdownList.style.height = '350px'

            /**
             * Here we position the dropdownList relative to the $refs.toggle Element.
             *
             * The 'offset' modifier aligns the dropdown so that the $refs.toggle and
             * the dropdownList overlap by 1 pixel.
             *
             * The 'toggleClass' modifier adds a 'drop-up' class to the Vue Select
             * wrapper so that we can set some styles for when the dropdown is placed
             * above.
             */
            const vm = this
            const popper = createPopper(component.$refs.toggle, dropdownList, {
                placement: 'bottom',
                modifiers: [
                    {
                        name: 'offset',
                        options: {
                            offset: [0, -1],
                        },
                    },
                    {
                        name: 'toggleClass',
                        enabled: true,
                        phase: 'write',
                        fn({ state }) {
                            component.$el.classList.toggle(
                                'drop-up',
                                state.placement === 'top'
                            )
                        },
                    },
                ],
            })
            
            /**
             * To prevent memory leaks Popper needs to be destroyed.
             * If you return function, it will be called just before dropdown is removed from DOM.
             */
            return () => popper.destroy()
        },
    },
}
</script>

<style>
.v-select.drop-up.vs--open .vs__dropdown-toggle {
    border-radius: 0 0 4px 4px;
    border-top-color: transparent;
    border-bottom-color: rgba(60, 60, 60, 0.26);
}

[data-popper-placement='top'] {
    border-radius: 4px 4px 0 0;
    border-top-style: solid;
    border-bottom-style: none;
    box-shadow: 0 -3px 6px rgba(0, 0, 0, 0.15);
}
</style>

<style>
.vs__dropdown-menu {
    z-index: 2000;
}
</style>

